<template>
    <a-card>
        <a-form class="table-search" ref="searchForm" layout="inline" :model="searchForm">
            <a-form-item label="基地名称" name="baseName">
                <a-input v-model:value="searchForm.baseName" placeholder="请输入基地名称"/>
            </a-form-item>
            <a-form-item>
                <a-button type="primary" @click="onSearch">查询</a-button>
                <a-button @click="onReset">重置</a-button>
            </a-form-item>
        </a-form>
        <a-table
            :columns="columns"
            :pagination="pagination"
            :data-source="dataSource"
            :loading="loading"
            @change="onTableChange">
            <!-- <template #index="{index}">{{ index + 1 }}</template> -->
            <template #baseLogo="{record}">
                <div  style="position: relative; width:35px; height:35px; margin: 3px 3px; overflow: hidden;">
                    <img-upload style="position: absolute; top:-35px; left:-35px" v-model:value="record.baseLogo" :showList="true" disabled />
                </div>
            </template>
            <template #action="{record}">
                <div class="table-row-operations">
                    <a @click="onEdit(record)" v-if="record.isHistory == 0">入驻</a>
                    <a @click="onEdit(record)" v-if="record.isHistory == 2">转移基地</a>
<!--                    <a @click="onEdit(record)" v-else>基地转移</a>-->
                    <span style="color: #1aad19" v-if="record.isHistory == 1">已入驻</span>
                </div>
            </template>
        </a-table>
    </a-card>
    <companyModal ref="modal" :form-primary-key-field="listKeyField" @finish="onFormEdited"/>
<!--    <CompanyDrawer ref="companymodal" :form-primary-key-field="listKeyField" @finish="onFormEdited" :baseId="baseId"/>-->
</template>

<script>
import companyModal from "./components/companyModal";
import {tableListMixin} from "@/mixins";
import {baseApi} from "@/api/innovationService";
// import CompanyDrawer from "@/views/Innovation/base/components/CompanyDrawer";

const columns = [
    // {title: "#", dataIndex: "index", key: "index", slots: {customRender: "index"}},
    {title: "基地logo", dataIndex: "baseLogo", key: "baseLogo", slots: {customRender: "baseLogo"}},
    {title: "基地名称", dataIndex: "baseName", key: "baseName"},
    {title: "基地联系人", dataIndex: "baseContactsName", key: "baseContactsName"},
    {title: "基地地址", dataIndex: "baseAddress", key: "baseAddress"},
    {title: "基地面积", dataIndex: "baseArea", key: "baseArea"},
    {title: "基地人数", dataIndex: "basePeopleNum", key: "basePeopleNum"},
    // {title: "基地描述", dataIndex: "baseDescription", key: "baseDescription",ellipsis:true,width:"100px"},
    {title: "操作", dataIndex: "action", key: "action", slots: {customRender: "action"}},
];
export default {
    name: "index",
    mixins: [tableListMixin],
    components: {
        // AddOrEditModal,CompanyDrawer
        companyModal
    },
    data() {
        return {
            columns,
            queryParam: {},
            listUrl: baseApi.pageList,
            listKeyField: "id",
            baseId:''
        }
    },
    methods: {
        onEdit(record) {
                this.onShowModal('modal', {baseId:record.id,companyCode:this.$ls.get("companyCode")});
        },
    }
}
</script>

<style scoped>

</style>
